import { isArray, isEmpty, has } from 'lodash';

const makeStatusMatcher = (adapter, selection, nodes) => {
  const selectedNodeIdsSet = new Set();
  const nodeChildSelected = {};

  if (selection) {
    const selectedNodes = isArray(selection) ? selection : [selection];

    selectedNodes.reduce((set, node) => {
      const id = makeNodeId(adapter, node);

      if (id) {
        set.add(id);
      }

      return set;
    }, selectedNodeIdsSet);

    const nodeParentIdByNodeId = nodes.reduce((hash, model) => {
      const nodeId = makeNodeId(adapter, model);
      const nodeParentId = makeNodeParentId(adapter, model);

      if (nodeId && nodeParentId) {
        hash[nodeId] = nodeParentId;
      }

      return hash;
    }, {});

    [...selectedNodeIdsSet].forEach(markNodeParentSelected);

    function markNodeParentSelected(nodeId) {
      if (nodeChildSelected[nodeId]) {
        return;
      }

      nodeChildSelected[nodeId] = true;

      return markNodeParentSelected(nodeParentIdByNodeId[nodeId]);
    }
  }

  return targetStatus => {
    if (!targetStatus) {
      return null;
    }

    return (node, filters) => {
      const nodeBuiltId = makeNodeId(adapter, node);

      if (!isEmpty(filters) && has(filters, 'first'))
        return node.status === targetStatus;
      return (
        nodeChildSelected[nodeBuiltId] ||
        node.status === undefined ||
        node.status === targetStatus ||
        selectedNodeIdsSet.has(nodeBuiltId)
      );
    };
  };

  function makeNodeId(adapter, node) {
    return adapter?.resolveNodeId ? adapter.resolveNodeId(node) : node?.id;
  }

  function makeNodeParentId(adapter, node) {
    return adapter?.resolveNodeParentId
      ? adapter.resolveNodeParentId(node)
      : node?.parentId;
  }
};

export default makeStatusMatcher;
